/**
 * Calendar events API (sessions, events, post-its, holidays).
 */

import apiClient from './api-client';
import type { CalendarEventType, CalendarEventsResponse } from '@/types/calendar.types';
import { parseWallDateTime, toLocalDateString } from '@/utils/format-date-utils';

/** `GET /calendar/events` — sessions, events, post-its, holidays. */
export const getCalendarEvents = async (
  startDate: Date,
  endDate: Date,
  types?: CalendarEventType[],
  vacationZoneId?: string,
  appMode?: 'in_person' | 'remote',
): Promise<CalendarEventsResponse> => {
  const params = new URLSearchParams();
  params.append('startDate', toLocalDateString(startDate));
  params.append('endDate', toLocalDateString(endDate));

  if (types && types.length > 0) {
    params.append('types', types.join(','));
  }

  if (vacationZoneId) {
    params.append('vacationZoneId', vacationZoneId);
  }

  if (appMode) {
    params.append('appMode', appMode);
  }

  const response = await apiClient.get<CalendarEventsResponse>(
    `/calendar/events?${params.toString()}`,
  );

  return {
    ...response.data,
    events: response.data.events.map((event) => ({
      ...event,
      startDate: parseWallDateTime(event.startDate),
      endDate: parseWallDateTime(event.endDate),
    })),
  };
};
